module.exports = __webpack_public_path__ + "static/img/icon_chengpei.4863f718.png";